
import { ADD_NEW_COMPANY } from "../../graphql";
import { LIST_ALL_COMPANIES, UPDATE_COMPANY } from "../../graphql";
import { post } from "../../services";
import { RESET_ALL_COMPANIES, SAVE_ALL_COMPANIES, TOGGLE_LOADING } from "../types";

export const updateCompany = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const apiResponse = await post("", {
            query: UPDATE_COMPANY,
            variables: requestData.data,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllCompanies());
            dispatch(listAllCompanies());
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllCompanies = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        const {
            companies: { pageSize, pageNumber, list },
        } = getState().companies;

        const apiResponse = await post("", {
            query: LIST_ALL_COMPANIES,
            variables: {
                pageSize: requestData?.isForDropdown ? 500 : pageSize,
                pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            const {
                list_all_hotel_companies: { data, hasMore },
            } = apiResponse.data.data;

            const updatedList = [...list, ...data];

            dispatch({
                type: SAVE_ALL_COMPANIES,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: pageNumber + 1,
                },
            });
        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllCompanies = () => {
    return (dispatch) => {
        dispatch({ type: RESET_ALL_COMPANIES });
    };
};

export const addNewCompany = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        const apiResponse = await post("", {
            query: ADD_NEW_COMPANY,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            const {
                add_new_company: { _id },
            } = apiResponse.data.data;

            await dispatch(resetAllCompanies());
            await dispatch(listAllCompanies());

            return _id;
        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};
